<template>
    <div>
        <v-dialog v-model="isDialog" :max-width="500">
            <v-card class="rounded-lg elevation-4">

                <v-card-title class="bg-header grey lighten-4">
                    <span class="text-h6 font-weight-bold grey--text text--darken-3">
                        <v-icon left color="primary">mdi-file-document-edit-outline</v-icon>
                        Versão do Relatório
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon small color="grey darken-1" @click="versaoRelatorioDialogClose">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pt-5 px-4 pb-3">
                    <v-container class="pa-0">

                        <v-row dense class="mb-3">
                            <v-col cols="12">
                                <v-file-input label="Relatório RPT" v-model="report" accept=".rpt" outlined dense
                                    prepend-inner-icon="mdi-upload-network" prepend-icon="" hide-details>
                                    <template v-slot:selection>
                                        <span>
                                            {{ report ? report.name : '' }}
                                        </span>
                                    </template>
                                </v-file-input>
                            </v-col>
                        </v-row>

                        <v-row dense class="mb-4">
                            <v-col cols="12">
                                <!-- <div class="caption red--text text--darken-1 mb-1">
                                    Deixe vazio para tornar o relatório padrão no Modelo
                                </div> -->
                                <v-text-field v-model="model.relv_vsic" label="Versão do SIC compatível" outlined dense
                                    type="text" />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" class="d-flex justify-end pt-2">
                                <v-btn color="success" class="text-none font-weight-bold px-4 elevation-1"
                                    @click="saveClick" elevation="1">
                                    <v-icon left small>mdi-content-save-check</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { RelversoesService } from '../../services/reports/relversoesService.js';

const relversoesService = new RelversoesService();

export default {
    props: {
        relm_id: String,
        dialog: Boolean,
    },
    components: {
    },
    data: () => ({
        loading: false,
        model: {
            relm_id: '',
            relv_vsic: '',
        },
        report: null,
    }),
    methods: {
        async editarRelmodelosClick(relmodelos) {
            this.relm_id = relmodelos.relm_id;
            this.dialogModeloRelatorioDialog = true;
        },
        async novoRelmodelosClick() {
            this.relm_id = "";
            this.dialogModeloRelatorioDialog = true;
        },
        async saveClick() {
            if (this.validaSalvar() == false) return;

            try {
                this.$isLoading(true);

                let form = new FormData()
                form.append('report', this.report)
                form.append('relm_id', this.relm_id)
                form.append('relv_vsic', this.model.relv_vsic)

                await relversoesService.create(this.relm_id, form);

                this.$store.dispatch('showSuccess', 'Salvo com sucesso!')
                this.versaoRelatorioDialogClose();
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.$isLoading(false);
            }
        },
        validaSalvar() {
            if (!this.report) {
                this.$store.dispatch('showError', 'Escolha o relatório rpt!')
                return false
            }

            if (!this.model.relv_vsic) {
                this.$store.dispatch('showError', 'Informe a versão do SIC compatível!')
                return false
            }

            var nomeArquivo = this.report.name
            var extensaoArquivo = nomeArquivo.substring(nomeArquivo.length - 3, nomeArquivo.length).toLowerCase()

            if (extensaoArquivo != 'rpt') {
                this.$store.dispatch('showError', 'Arquivo inválido, deve ser .rpt!')
                return false
            }

            return true
        },
        versaoRelatorioDialogClose() {
            this.$emit('versaoRelatorioDialogClose')
        }
    },
    computed: {
        isDialog: {
            get() {
                return this.dialog
            },
            set() {
                this.versaoRelatorioDialogClose();
            }
        }
    },
    watch: {
        async dialog() {
            this.model = this.$options.data().model;// igual um new
            this.report = null;
        }
    }
}
</script>
